import React from 'react';
import { Alert, Form, Input, Select } from 'antd';
import { MCP_AUTH_OPTIONS } from './toolFormUtils';

export default function AddMcpServerForm({ form, onFinish }) {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ auth_type: 'auto' }}>
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
        message="Paste the MCP server URL. We will connect and open sign-in if required."
      />
      <Form.Item name="name" label="Name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="url" label="MCP server URL" rules={[{ required: true }]}>
        <Input placeholder="https://mcp.example.com/v2" />
      </Form.Item>
      <Form.Item name="bearer_token" label="Credentials (optional bearer token)">
        <Input.Password placeholder="Static API token, if provided" />
      </Form.Item>
      <Form.Item name="auth_type" label="Advanced auth">
        <Select options={MCP_AUTH_OPTIONS} />
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => getFieldValue('auth_type') === 'oauth_client_credentials' && (
          <>
            <Form.Item name="token_url" label="Token URL" rules={[{ required: true }]}>
              <Input placeholder="https://auth.example.com/oauth/token" />
            </Form.Item>
            <Form.Item name="client_id" label="Client ID" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
            <Form.Item name="client_secret" label="Client secret" rules={[{ required: true }]}>
              <Input.Password />
            </Form.Item>
          </>
        )}
      </Form.Item>
    </Form>
  );
}
